// extracted by mini-css-extract-plugin
module.exports = {"reviews":"Reviews_reviews__2HSk6","title":"Reviews_title__vk7ka","dots":"Reviews_dots__137RU"};